import { render, staticRenderFns } from "./PaqProcedimiento.vue?vue&type=template&id=02431069"
import script from "./PaqProcedimiento.vue?vue&type=script&lang=js"
export * from "./PaqProcedimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports